module.exports = require('./lib/schema-inspector');



//////////////////
// WEBPACK FOOTER
// ./~/schema-inspector/index.js
// module id = 1703
// module chunks = 1